<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 90" style="background: white">
    <title>background waves</title>
    <g>
      <g data-name="background shapes">
        <path fill="#e6e6ff" class="cls-8" d="M1.49,43.46c31.26,26.08,134,74.87,475.53,14.59,212.23-37.46,519.07-17.86,547,7.81V429.77H0V42.21Z" />
      </g>
    </g>
  </svg>